










































import { ItemDetailsTemplate } from '@/interfaces/item-details-template.inteface';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import PermissionsService from '@/services/permissions.service';

const templatesModule = namespace('templates');

@Component
export default class ItemDetailsTemplateMenu extends Vue {
  @Prop() itemDetailsTemplates!: ItemDetailsTemplate[];

  @templatesModule.Action deleteWithConfirmation: any;

  templateLoadMenu = false;

  get canSetGlobalTemplates(): boolean {
    return PermissionsService.can('global_item_details_templates', 'create');
  }

  canDeleteTemplate(template: ItemDetailsTemplate){
    if (template.isGlobal) return this.canSetGlobalTemplates;
    return true;
  }

  deleteTemplate(template: ItemDetailsTemplate) {
    this.deleteWithConfirmation({
      itemDetailsTemplate : template
    });
  }

  @Emit('item-details-loaded')
  setOrderDetails(itemDetails: string): string {
    return itemDetails;
  }

}
